<template>
  <div class="question-container bg-secondary-3">
    <div
      v-for="(question, questionIndex) in questionsList"
      :key="questionIndex"
      class="question-item row mx-auto col px-0">
      <div class="question-box-content row mx-auto col-12 d-flex justify-content-between align-items-end px-0">
        <p
          class="col px-0 color-gray-6"
        >
          {{ question.description }}
        </p>

        <div
          class="dropdown custom-radio-container d-flex align-items-end px-0"
          :class="{
            'col':!removeColHeader
          }"
        >
          <action-button
            id="dropdownLevelOptionsButton"
            class="btn dropdown-btn font-weight-bold"
            :disabled="isReadonly"
            :class="`option-${getLevelOptionName(question.submittedAnswerTypeId)}`"
            @click="toogleOptionsPopup"
          >
            <span class="dropdown-selected-title">
              <span v-if="question.submittedAnswerTypeId">
                {{ getLevelOptionName(question.submittedAnswerTypeId) }}
              </span>
              <span v-else>
                <i class="fas fa-chevron-down" />
              </span>
            </span>
          </action-button>
          <div
            v-if="showOptions"
            class="dropdown-menu dropdown-menu-right"
          >
            <div
              v-for="(option, index) in levelOptions"
              :key="index"
              class="dropdown-rounded-item"
            >
              <action-button
                class="btn option-btn font-weight-bold"
                :class="`option-${option.name}`"
                @click="updateSelectedAnswer(question.id, option)"
              >
                {{ option.name }}
              </action-button>
            </div>
          </div>
        </div>
      </div>
      <Error
        v-if="validate && question.submittedAnswerTypeId == null"
        :is-alert-mode="false"
        class="mt-0"
        variant="no-border"
        message="Favor de seleccionar"
      />
    </div>
    <div class="d-flex justify-content-end">
      <action-button
        v-if="isDraft"
        type="button"
        text="Guardar"
        i="fa fa-save pr-2"
        variant="success"
        @click="onSaveQuestions"
      />
    </div>
  </div>
</template>

<script>
import store from "@/store/index";
import peiCode from "@/utils/constants/pei/peiCode";
import AnswerType, { levelAnswerTypes as levelTypes } from "@/utils/constants/pei/serviceNeedQuestionnaire/answerType";
import needsService from "@/services/pei/serviceNeedQuestionnaire";
import ActionButton from "ActionButton";
import Error from "@/components/common/Error";
import Dropdown from "dropdown";
import CustomDropDownRounded from "@/components/common/CustomDropDownRounded";
import CustomDropdown from "@/components/common/CustomDropDown";
import peiStatus from '@/utils/constants/pei/peiStatus';
export default {
  name: "QuestionsMobility",
  components: {
    ActionButton,
    Dropdown,
    CustomDropDownRounded,
    CustomDropdown,
    Error,
  },
  props: {
    peiId:{
      type: String,
      default: () => "",
    },
    isReadonly: {
      type: Boolean,
      default: () => false
    },
    removeColHeader:{
      type: Boolean,
      default: false
    },
    validate: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      questions: [],
      showOptions: false,
    };
  },
  async mounted() {
    if(!this.questions?.length) {
      await this.getQuestions();
    }
  },
  computed: {
    selectedPeiId() {
      return store.getters.SelectedPei;
    },
    questionsList() {
      return this.questions;
    },
    isValidLevelOfPerformance() {
      return (questionItem) => [AnswerType.L0, AnswerType.L1, AnswerType.L2].includes(questionItem?.submittedAnswerTypeId);
    },
    levelAnswerTypes() {
      return [AnswerType.L0, AnswerType.L1, AnswerType.L2, AnswerType.L3, AnswerType.L4, AnswerType.L5];
    },
    levelOptions() {
      return levelTypes;
    },
    getLevelOptionName() {
      return (levelOptionId) => {
        const option = this.levelOptions.find(x => x.id === levelOptionId);

        return option?.name || '';
      };
    },
    isDraft() {
      return store.getters.SelectedPeiStatus == peiStatus.Borrador;
    },
  },
  methods: {
    async getQuestions() {
      const _questions = await needsService.getQuestions({
        peiId: this.selectedPeiId ?? this.peiId,
        peiCodeId: peiCode.AsistenteMovilidad,
      });
      this.questions = _questions.map((questionItem) => {
        let _possibleAnswers = questionItem.possibleAnswers.filter((item) => this.levelAnswerTypes.includes(item.id));
        
        return ({
          ...questionItem,
          documentModel: null,
          uploadDocumentPanel: false,
          possibleAnswers: _possibleAnswers,
        });
      });
    },
    toogleOptionsPopup() {
      this.setShowOptions(!this.showOptions);
    },
    setShowOptions(open) {
      this.showOptions = open;
    },
    updateSelectedAnswer(questionId, option) {
      const currentQuestion = this.questions.find(x => x.id === questionId);
      
      if (!currentQuestion?.id) return;

      currentQuestion.submittedAnswerTypeId = option.id;
      this.setShowOptions(false);
    },
    async onSaveQuestions() {
      const payload = this.questionsList.map((questionItem) => ({
        id: questionItem.submittedId,
        peiId: this.selectedPeiId,
        questionServiceNeedId: questionItem.id,
        answerTypeId: questionItem.submittedAnswerTypeId,
        document: null,
        comment: null,
      }));

      const isValidLevelOfPerformanceValue = this.questionsList.some(questionItem => this.isValidLevelOfPerformance(questionItem));
      const justified = isValidLevelOfPerformanceValue;

      this.$emit('save-questions', { answers: payload, isJustified: justified });
    },
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables/_colors.scss';

.question-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 20px 36px;
}
.question-item {
  gap: 30px;
}
.question-box-content {
  border-bottom: solid 1px map-get($colors, 'gray-5');
}
.custom-radio-container {
  padding-top: 15px;
}
.custom-radio-button {
  margin-left: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 60px;
  height: 60px;
}
.custom-radio-button, .radio-label {
  cursor: pointer;
}
.show-check {
  opacity: 1 !important;
}
.step-label {
  display: flex;
  flex-direction: column;
  font-family: Lato;
  font-weight: 500;
}

.cr.rounded-circle.cr-inactive  {
  border-color: map-get($colors, 'gray-8');
}
.cr.rounded-circle.cr-active {
  border-color: map-get($colors, 'white');
}
.cr-error {
  border-color: map-get($colors, 'red');
}
.dropdown-menu {
  display: flex;
  justify-content: space-around;
  padding: 10px 5px;
}
.dropdown-btn {
  width: 60px;
  height: 60px;
  background-color: map-get($colors, 'gray-9');
}

/************* option button *****************/
.option-btn {
  color: map-get($colors, 'black');
  margin: 0px 5px;
}
.option-L0 {
  background-color: map-get($colors, 'pink-2');
}
.option-L1 {
  background-color: map-get($colors, 'pink');
}
.option-L2 {
  background-color: map-get($colors, 'violet');
}
.option-L3 {
  background-color: map-get($colors, 'yellow-2');
}
.option-L4 {
  background-color: map-get($colors, 'blue-light');
}
.option-L5 {
  background-color: map-get($colors, 'green-light');
}
/************* option button *****************/
</style>
